import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemHealthTurnip extends Item {
    constructor() {
        super(definitions.ITEM_ID.HEALTH_TURNIP, texture("prop_pickup_turnip_00"));

        this._consumable = true;
    }

    init() {
        super.init();

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.6, new PIXI.Point(0, 0));
    }
}